// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.final {
  background-color: #fbfbfb;
  border-radius: 1rem;
  grid-gap: 20px;
  padding: 24px 16px;
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr;
}
.final__image {
  width: 100%;
}
.final__image img {
  width: 100%;
}
.final__container {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  overflow: hidden;
}
@media all and (min-width: 1280px) {
  .final {
    width: 1000px;
    margin-top: 2rem;
    padding: 30px;
    grid-template-columns: 1fr 1fr;
    grid-gap: 30px;
  }
}
.final__content-container {
  display: flex;
  flex-direction: column;
}
.final__heading {
  margin-bottom: 12px;
}
.final__paragraph {
  margin-bottom: 2rem;
}
.final__form {
  display: flex;
  grid-gap: 1rem;
  height: 100%;
}
.final__fields {
  display: flex;
  grid-gap: 1.25rem;
  flex-direction: column;
  height: 100%;
}
@media all and (min-width: 1280px) {
  .final__fields {
    grid-gap: 1rem;
  }
}
.final__button-container {
  display: flex;
  flex-grow: 1;
  align-items: flex-end;
}
.final__inner-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 8px;
  height: fit-content;
  margin-bottom: 72px;
}
@media all and (min-width: 1280px) {
  .final__inner-container {
    padding: 0;
  }
}
.final__outer-container {
  background: linear-gradient(180deg, #1F48B1 0%, #0D1F4B 100%), center center;
  display: flex;
  overflow: hidden;
}
.final__footer {
  display: flex;
  flex-grow: 1;
  align-items: flex-end;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/Form/Form.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,yBC8BU;ED7BV,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EAEA,aAAA;EACA,0BAAA;AAFF;AAKE;EACE,WAAA;AAHJ;AAKI;EACE,WAAA;AAHN;AAQE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AANJ;AASE;EA3BF;IA4BI,aAAA;IAEA,gBAAA;IACA,aAAA;IACA,8BAAA;IAEA,cAAA;EARF;AACF;AAWE;EACE,aAAA;EACA,sBAAA;AATJ;AAYE;EACE,mBAAA;AAVJ;AAaE;EACE,mBAAA;AAXJ;AAcE;EACE,aAAA;EACA,cAAA;EACA,YAAA;AAZJ;AAeE;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;AAbJ;AAeI;EANF;IAQI,cAAA;EAbJ;AACF;AAgBE;EACE,aAAA;EACA,YAAA;EACA,qBAAA;AAdJ;AAiBE;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAfJ;AAiBI;EARF;IASI,UAAA;EAdJ;AACF;AAiBE;EACE,4EAAA;EACA,aAAA;EACA,gBAAA;AAfJ;AAkBE;EACE,aAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;AAhBJ","sourcesContent":["@import 'src/styles/variables';\n\n.final {\n  background-color: $white-100;\n  border-radius: 1rem;\n  grid-gap: 20px;\n  padding: 24px 16px;\n  margin-top: 20px;\n\n  display: grid;\n  grid-template-columns: 1fr;\n\n\n  &__image {\n    width: 100%;\n\n    img {\n      width: 100%;\n    }\n  }\n\n\n  &__container {\n    display: flex;\n    flex-direction: column;\n    min-height: 100dvh;\n    overflow: hidden;\n  }\n\n  @media all and (min-width: $desktop) {\n    width: 1000px;\n    //height: 528px;\n    margin-top: 2rem;\n    padding: 30px;\n    grid-template-columns: 1fr 1fr;\n\n    grid-gap: 30px;\n  }\n\n\n  &__content-container {\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__heading {\n    margin-bottom: 12px;\n  }\n\n  &__paragraph {\n    margin-bottom: 2rem;\n  }\n\n  &__form {\n    display: flex;\n    grid-gap: 1rem;\n    height: 100%;\n  }\n\n  &__fields {\n    display: flex;\n    grid-gap: 1.25rem;\n    flex-direction: column;\n    height: 100%;\n\n    @media all and (min-width: $desktop) {\n\n      grid-gap: 1rem;\n    }\n  }\n\n  &__button-container {\n    display: flex;\n    flex-grow: 1;\n    align-items: flex-end;\n  }\n\n  &__inner-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    padding: 0 8px;\n    height: fit-content;\n    margin-bottom: 72px;\n\n    @media all and (min-width: $desktop) {\n      padding: 0;\n    }\n  }\n\n  &__outer-container {\n    background: linear-gradient(180deg, #1F48B1 0%, #0D1F4B 100%), center center;\n    display: flex;\n    overflow: hidden;\n  }\n\n  &__footer {\n    display: flex;\n    flex-grow: 1;\n    align-items: flex-end;\n    justify-content: center;\n  }\n}","$headerHeightMobile: 60px;\n$headerHeightDesktop: 80px;\n\n$desktop: 1280px;\n\n\n// accents\n$main-blue-gradient: #100;\n$main-dark-blue: #1F106D;\n$main-mid-blue-100: #1F48B1FF;\n$main-mid-blue-50: #1F48B180;\n$main-light-blue: #A1C7FF;\n$hover-main-blue: #331CAA;\n$pressed-main-blue: #011C5A;\n$progress-bar-red: #D62B1F;\n$progress-dot-disabled: #D9D9D9;\n\n// brands\n$alfa-bank: #EF3124;\n$vsk: #4544EE;\n$h: #2078FE;\n$vtb: #002882;\n$robo-finance: #00BF6E;\n$x-5: #5FAF2D;\n$sport-master: #1551E5;\n\n// black\n$black-100: #151515FF;\n$black-75: #151515BF;\n$black-50: #15151580;\n$black-25: #15151540;\n\n// white\n$white-100: #FBFBFBFF;\n$white-75: #FBFBFBBF;\n$white-50: #FBFBFB80;\n$white-25: #FBFBFB40;\n\n// input\n$input-background: #F1F5F9;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
